import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Dropdown } from 'semantic-ui-react';

import $ from "jquery";
import Server from '../../../functions/server';

class Edit extends React.Component {

    state = {
        executives: []
    }


    getexecutiveName() {
        if (this.state.edit) {
            let executives = this.state.executives;
            let executiveOption = this.props.executive;
            let executiveName = '';
            executiveOption.map((c) => {
                executives.map((v) => {
                    if (v == c.value) {
                        if (executiveName == '') {
                            executiveName = c.text;
                        }
                        else {
                            executiveName = executiveName+', '+c.text;
                        }
                    }
                })
            })
            return executiveName;
        }
        else {
            let executiveId = this.props.item.executive;
            try {
                executiveId = executiveId.split(',');
            } catch (error) {
                executiveId = [executiveId];
            }
            let executive = this.props.executive;
            let executivename = '';
            executive.map((c) => {
                executiveId.map((v) => {
                    if (c.value == v) {
                        if (executivename == '') {
                            executivename = c.text;
                            return;
                        }
                        executivename = executivename+', '+c.text;
                    }
                })
            })
            return executivename;
        }
    }

    getExecutiveDailog() {
        if (!this.props.menuPermission.edit) { 
            alert('You Are Not Allow To Access!!!!'); return; 
        }
        let executiveId = this.props.item.executive;
        let executiveIds = [];
        try {
            executiveIds = executiveId.split(',');
        } catch (error) {
            executiveIds = [executiveId]
        }
        this.setState({ executives: executiveIds, dialog: true, edit: true })
    }

    customer = (f, { value }) => {
        this.check(value, this.state.executives);
        this.setState({ executives: value });
      }

      check(value, oldValue) {
        let length = value.length;
        if (length > oldValue.length) {
          let x = (value[value.length - 1]);
          this.add(x);
        } else if (length < oldValue.length) {
          let array1 = oldValue.filter(val => !value.includes(val));
          this.remove(array1[0]);
        }
      }
    
      add(value) {
        let context = this;
        let data = {'id': this.props.id, 'executive': value};
        context.setState({ load: true, message: 'Adding Executive!!!' })
        $.ajax({
          type: 'POST', data: data,
          url: Server() + 'customer/add.php',
          success: function(data) {
            if (data == 1) {
              context.setState({ load: false })
            }
          },
          error: function(e) {
            context.setState({ load: false })
          }
        });
      }

    remove(value) {
        let context = this;
        let data = {'id': this.props.id, 'executive': value};
        context.setState({ load: true, message: 'Adding Executive!!!' })
        $.ajax({
            type: 'POST', data: data,
            url: Server() + 'customer/remove.php',
            success: function(data) {
                context.setState({ load: false })
            },
            error: function(e) {
                context.setState({ load: false, })
            }
        });
    }

    render() {
        let executiveName = this.getexecutiveName();
        if (this.state.dialog) {
            return (
                <Dialog fullWidth={true} maxWidth={'sm'} open={this.state.dialog}
                    onClose={ () => { this.setState({ dialog: false }) } }
                    aria-labelledby="max-width-dialog-title" >
                    <DialogTitle id="max-width-dialog-title">{'Executive'}</DialogTitle>
                    <DialogContent style={{height: 250}}>
                        <Dropdown placeholder='Executive' style={{ borderColor: '#5A9CBB', fontSize: 11 }}
                        fluid search selection multiple onChange={this.customer}
                        options={this.props.executive} value={this.state.executives} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ dialog: false }) } } color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        }
        return (
            <td onClick={this.getExecutiveDailog.bind(this)}>
                <b><u style={{color: '#11B2D2'}}>{executiveName}</u></b>
            </td>
        );
    }
}

export default Edit;
